import Header from "../components/Header";
import {useEffect, useMemo, useState} from "react";
import {NavLink, useParams} from "react-router-dom";
import Data from "../../Data";
import Error from "../components/Error";
import Meta from "../../../components/Meta";

const View = () => {
    const { id, bundleId } = useParams();

    const [experience, setExperience] = useState({});
    const [bundle, setBundle] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);

    useEffect(async () => {
        try {
            const experience = await Data.fetchExperienceById({ id })
            setExperience(experience.data)
            const result = await Data.fetchBundleById({ id: bundleId })
            setBundle(result.data)
        } catch(error){
            setError(true)
        }
    }, []);

    const firstEvent = useMemo(() => bundle?.events?.length ? [...bundle.events].sort((a,b)=> new Date(a.date) - new Date(b.date))[0] : null, [bundle]);

    return (
        <>
            <Meta title={`Bundle — ${bundle?.name || ''}`} />
            <Header heading={bundle?.name || 'Bundle'} backToLabel={experience.name} backToTo={`/admin/experiences/${id}`} />
            <div className={"p-3 lg:p-6 grid grid-cols-1 gap-3 lg:gap-6 w-full overflow-x-scroll"}>
                {error ? <Error message={"There was a problem loading the bundle."} /> : null}

                {bundle ? (
                    <div className={"bg-white w-full rounded-lg border drop-shadow-sm [&>*]:py-4 [&>*]:px-6"}>
                        <div className={"my-2 flex justify-between items-center"}>
                            <p className={"text-lg"}>Bundle Details</p>
                        </div>

                        <div className={"grid grid-cols-3 gap-2 items-start border-t"}>
                            <p>Name</p>
                            <p className={"text-textGrey col-span-2"}>{bundle.name}</p>
                        </div>
                        <div className={"grid grid-cols-3 gap-2 items-start border-t"}>
                            <p>Price (per person)</p>
                            <p className={"text-textGrey col-span-2"}>£{bundle.price}</p>
                        </div>
                        <div className={"grid grid-cols-3 gap-2 items-start border-t"}>
                            <p>Refund Window Override</p>
                            <p className={"text-textGrey col-span-2"}>{bundle.overrideRefundWindow ?? '-'}</p>
                        </div>
                        <div className={"grid grid-cols-3 gap-2 items-start border-t"}>
                            <p>Events</p>
                            <div className={"text-textGrey col-span-2"}>
                                {bundle.events.map(ev => (
                                    <p key={ev._id}>{new Date(ev.date).toLocaleDateString()} {new Date(ev.date).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</p>
                                ))}
                            </div>
                        </div>
                        {firstEvent ? (
                            <div className={"grid grid-cols-3 gap-2 items-start border-t"}>
                                <p>Starts</p>
                                <p className={"text-textGrey col-span-2"}>{new Date(firstEvent.date).toLocaleDateString()}</p>
                            </div>
                        ) : null}
                    </div>
                ) : null}
            </div>
        </>
    )
}

export default View


